// extracted by mini-css-extract-plugin
export default {"icon_close":"style_icon_close__M0NAz"};